/* Player-side mod store — workshop config packs that live on the client.
   Slots: menu_theme, boot_pack, sound_pack, cad_theme, phone_theme.
   Installing downloads the pack into the registry; each slot has ONE active pack;
   every installed pack can be toggled on/off (disabled active packs fall back to stock). */

const LS_INSTALLED = "nc_packs_v2";       // {slot: [modDoc, ...]}
const LS_ACTIVE = "nc_packs_active_v2";   // {slot: packId}
const LS_ENABLED = "nc_packs_enabled_v2"; // {packId: false} (absent = enabled)

export const PACK_SLOTS = {
  menu_theme: "Menu Theme",
  boot_pack: "Boot Sequence",
  sound_pack: "Sound Pack",
  cad_theme: "CAD Tablet Theme",
  phone_theme: "Phone Theme",
};

const read = (k, fb) => { try { return JSON.parse(localStorage.getItem(k)) ?? fb; } catch { return fb; } };
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

// one-time migration from the v1 menu-theme store
(function migrate() {
  if (read(LS_INSTALLED, null)) return;
  const installed = {};
  const old = read("nc_menu_packs_v1", []);
  if (old.length) installed.menu_theme = old;
  write(LS_INSTALLED, installed);
  const active = {};
  const oldActive = localStorage.getItem("nc_menu_theme_v1");
  if (oldActive && oldActive.startsWith("pack:")) active.menu_theme = oldActive.slice(5);
  write(LS_ACTIVE, active);
})();

export function installPack(mod) {
  const slot = mod.pack_type;
  if (!PACK_SLOTS[slot]) return;
  const all = read(LS_INSTALLED, {});
  const list = all[slot] || [];
  if (!list.some((m) => m.id === mod.id)) list.push(mod);
  all[slot] = list;
  write(LS_INSTALLED, all);
  const active = read(LS_ACTIVE, {});
  active[slot] = mod.id; // newest install becomes active
  write(LS_ACTIVE, active);
  setPackEnabled(mod.id, true);
}

export function listInstalled(slot = null) {
  const all = read(LS_INSTALLED, {});
  if (slot) return all[slot] || [];
  return all;
}

export function isPackInstalled(id) {
  return Object.values(read(LS_INSTALLED, {})).flat().some((m) => m.id === id);
}

export function setActivePack(slot, id) {
  const active = read(LS_ACTIVE, {});
  active[slot] = id;
  write(LS_ACTIVE, active);
}

export function setPackEnabled(id, on) {
  const en = read(LS_ENABLED, {});
  if (on) delete en[id]; else en[id] = false;
  write(LS_ENABLED, en);
}

export function isPackEnabled(id) {
  return read(LS_ENABLED, {})[id] !== false;
}

export function activePack(slot) {
  const id = read(LS_ACTIVE, {})[slot];
  if (!id || !isPackEnabled(id)) return null;
  return (read(LS_INSTALLED, {})[slot] || []).find((m) => m.id === id) || null;
}
